/**
 * Messages groupés réseau (parité legacy sa-broadcast) — données PURES et helpers.
 * Templates pré-définis, audiences ciblées, canaux. Testable séparément de l'I/O.
 */

export interface BroadcastTemplate {
  key: string;
  emoji: string;
  label: string;
  type: string;
}

/** Templates pré-définis (legacy). */
export const BROADCAST_TEMPLATES: BroadcastTemplate[] = [
  { key: 'info', emoji: 'ℹ️', label: 'Info', type: 'info' },
  { key: 'closure', emoji: '🚫', label: 'Fermeture', type: 'closure' },
  { key: 'maintenance', emoji: '🛠️', label: 'Maintenance', type: 'maintenance' },
  { key: 'alert', emoji: '⚠️', label: 'Alerte', type: 'alert' },
  { key: 'offer', emoji: '⚡', label: 'Offre spéciale', type: 'offer' },
  { key: 'survey', emoji: '💬', label: 'Sondage', type: 'survey' },
];

export type AudienceKey =
  | 'managers'
  | 'all_customers'
  | 'loyal_customers'
  | 'dormant_customers';

export interface Audience {
  key: AudienceKey;
  label: string;
  /** true = destinataires = gérants/restos ; false = clients finaux. */
  managers: boolean;
}

/** Audiences ciblables (legacy). */
export const AUDIENCES: Audience[] = [
  { key: 'managers', label: '🏢 Tous les gérants du réseau', managers: true },
  { key: 'all_customers', label: '👥 Tous les clients (réseau)', managers: false },
  { key: 'loyal_customers', label: '💎 Clients fidèles (3+ commandes)', managers: false },
  { key: 'dormant_customers', label: '😴 Clients dormants (inactifs 45j+)', managers: false },
];

export type Channel = 'email' | 'push';

/** Une campagne prête à envoyer. */
export interface BroadcastDraft {
  type: string;
  emoji: string;
  title: string;
  body: string;
  url?: string;
  audience: AudienceKey;
  channels: Channel[];
}

/** Validation : titre + corps + au moins un canal. Pur. */
export function validateBroadcast(d: BroadcastDraft): string[] {
  const errs: string[] = [];
  if (!d.title.trim()) errs.push('Titre requis');
  if (!d.body.trim()) errs.push('Message requis');
  if (d.channels.length === 0) errs.push('Au moins un canal (email ou push)');
  return errs;
}

/** Libellé lisible d'une audience. Pur. */
export function audienceLabel(key: AudienceKey): string {
  return AUDIENCES.find((a) => a.key === key)?.label ?? key;
}

/** Estimation simple du nombre de destinataires selon l'audience. Pur. */
export function estimateRecipients(
  audience: AudienceKey,
  counts: { tenants: number; customers: number; loyal: number; dormant: number },
): number {
  switch (audience) {
    case 'managers':
      return counts.tenants;
    case 'all_customers':
      return counts.customers;
    case 'loyal_customers':
      return counts.loyal;
    case 'dormant_customers':
      return counts.dormant;
  }
}
